import { useSelector } from 'react-redux';
import Image from '../../Utils/Image/image-component';

/**
 * Always On Air - High-Impact Google Review Card
 * Features full-color branding and no-crop portrait-safe image handling.
 */
const ReviewCard = ({ name, reviewText, shortText, image, reviewDate = "a month ago" }) => {
    const { dir } = useSelector((state) => state.systemData || { dir: 'ltr' });

    // Authentic Google Avatar Palette
    const avatarColors = ['bg-[#1a73e8]', 'bg-[#d93025]', 'bg-[#f9ab00]', 'bg-[#188038]', 'bg-[#af5cf7]'];
    const colorIndex = name ? name.length % avatarColors.length : 0;

    return (
        <div dir={dir} className='flex py-2 h-full'>
            <div className={`bg-white font-assistant p-5 w-[210px] lg:w-[320px] rounded-2xl shadow-md border border-slate-100 dark:bg-zinc-900 dark:border-zinc-800 flex flex-col group transition-all duration-300 hover:shadow-xl ${dir === 'rtl' ? 'text-right' : 'text-left'}`}>

                <article className="flex flex-col h-full">

                    {/* --- HEADER --- */}
                    <div className="flex items-start justify-between mb-4">
                        <div className="flex items-center gap-3">
                            <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold ${avatarColors[colorIndex]} shrink-0`}>
                                {name ? name.charAt(0).toUpperCase() : 'G'}
                            </div>
                            <div className="flex flex-col">
                                <h3 className="text-sm font-bold text-gray-900 dark:text-white leading-tight">{name}</h3>
                                <div className="flex gap-0.5 mt-0.5">
                                    {[...Array(5)].map((_, i) => (
                                        <svg key={i} className="w-3.5 h-3.5 text-[#fbbc04]" fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                        </svg>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <img alt="Google" src="https://sawpy-assets.s3.us-east-2.amazonaws.com/logos/google.png" className="w-7 h-7 object-contain" />
                    </div>

                    {/* --- IMAGE --- */}
                    {image && (
                        <div className="mb-4 w-full h-36 rounded-xl overflow-hidden bg-gray-100 dark:bg-zinc-800/50 flex items-center justify-center relative">
                            <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover blur-xl opacity-15 scale-110 pointer-events-none" />
                            <Image src={image} alt={`Review by ${name}`} className="relative z-10 max-w-full max-h-full object-contain mx-auto" useSekeleton={true} quality={80} />
                        </div>
                    )}

                    {/* --- REVIEW TEXT --- */}
                    <div className="flex-grow space-y-1.5">
                        {shortText && (
                            <h4 className="text-xs font-black text-primary-950 dark:text-white uppercase er">{shortText}</h4>
                        )}
                        <p className="text-sm leading-relaxed text-gray-600 dark:text-zinc-300 font-medium italic line-clamp-4">
                            "{reviewText}"
                        </p>
                    </div>

                </article>
            </div>
        </div>
    );
};

export default ReviewCard;